<script setup lang="ts">

import {CustomDTOExpression} from "@/utils/presenters/interfaces.ts";
import Operator from "@/utils/constants/Operator.ts";
import CriteriaTreeUtils from "@/utils/common/CriteriaTreeUtils.ts";
import CriteriaOpenBracketWidget from "@/views/CriteriaOpenBracketWidget.vue";
import CriteriaExpression from "@/views/CriteriaExpression.vue";
import {PropType, ref, Ref} from "vue";
import {QTreeNode} from "quasar";
import {storeToRefs} from "pinia";
import {useNamaFlagsStore} from "@/stores/nama-flags-store.ts";
import CriteriaField = namaTypes.CriteriaField;

const {compactMode, isUltra} = storeToRefs(useNamaFlagsStore());

const props = defineProps({
  ownerEntity: {type: String, required: true,},
  criteriaFields: {type: Object as PropType<CriteriaField[]>, required: true},
  isHasHeight: {type: Boolean, required: false},
  isFilterEmpty: {type: Boolean, required: true},
  onCriteriaViewEnterDown: {type: Function, required: true}
})
const emit = defineEmits(["enterDown"])
const criteriaTree = defineModel('criteriaTree', {
  type: Object as PropType<QTreeNode<CustomDTOExpression>[]>,
  required: true,
});

const expanded: Ref<any[]> = ref(expandAllCriteriaNodes());

function updateExpanded() {
  expanded.value = expandAllCriteriaNodes();
}

defineExpose({updateExpanded})

function expandAllCriteriaNodes() {
  let ids = [];
  for (let expression of criteriaTree.value) {
    appendIdsOfCrtExpression(expression, ids);
  }
  return ids;
}

function appendIdsOfCrtExpression(e: CustomDTOExpression, ids: any[]) {
  if (!e)
    return;
  ids.push(e.id);
  if (!e.children)
    return;
  for (let child of e.children) {
    appendIdsOfCrtExpression(child as CustomDTOExpression, ids);
  }
}

const expressions = ref({});

function removeChild(node: CustomDTOExpression, tree: QTreeNode<CustomDTOExpression>[]) {
  CriteriaTreeUtils.removeChild(node, tree);
  console.log(expressions.value);
  let nodeIdToFocus = Object.keys(expressions.value).filter((k) => k > node.id + '')[0];
  if (nodeIdToFocus) {
    console.log(expressions.value[nodeIdToFocus])
    expressions.value[nodeIdToFocus].focusValueWidget();
  } else {
    let beforeMe = Object.keys(expressions.value).filter((k) => k < node.id + '');
    nodeIdToFocus = beforeMe[beforeMe.length - 1];
    if (nodeIdToFocus) {
      console.log(expressions.value[nodeIdToFocus])
      expressions.value[nodeIdToFocus].focusValueWidget();
    }
  }
}

function appendRef(el: any, node: CustomDTOExpression) {
  if (el)
    expressions.value[node.id + ''] = el;
  else
    delete expressions.value[node.id + ''];
}
</script>

<template>
  <div class="tw-w-full" :class="[isHasHeight ? 'tw-h-[inherit]' : 'tw-h-full']">
    <q-tree :nodes="criteriaTree" node-key="id" default-expand-all v-model:expanded="expanded"
            :dense="compactMode"
            class="!tw-h-full tw-w-full nama-criteria-tree nama-criteria-tree-collapsible">
      <template v-slot:default-header="prop">
        <div v-if="(prop.node as CustomDTOExpression).operator === Operator.OpenBracket"
             class="tw-w-full tw-h-[52px] compact:tw-h-[44px] ultra:tw-h-[36px] tw-content-center">
          <CriteriaOpenBracketWidget v-model="(prop.node as CustomDTOExpression)"
                                     @removeExpression="removeChild(prop.node, criteriaTree)"
                                     @appendIdInExpanded="(newId)=>expanded.push(newId)" :owner-entity="ownerEntity"
                                     :root="criteriaTree[0] === prop.node" :expanded="expanded.includes(prop.node.id)"
                                     :isFilterEmpty="isFilterEmpty" :on-criteria-view-enter-down="onCriteriaViewEnterDown">
            <slot></slot>
          </CriteriaOpenBracketWidget>
        </div>
        <template v-else>
          <CriteriaExpression @keypress.space.stop v-model="prop.node" :criteria-fields="criteriaFields"
                              @removeExpression="removeChild(prop.node, criteriaTree)" :owner-entity="ownerEntity"
                              @appendNewExpression="CriteriaTreeUtils.appendExpressionNextToSource(prop.node,false, criteriaTree)"
                              @appendCopyExpression="CriteriaTreeUtils.appendExpressionNextToSource(prop.node,true, criteriaTree)"
                              @enterDown="()=>$emit('enterDown')" :ref="(el)=>appendRef(el,prop.node)"
          />
        </template>
      </template>
    </q-tree>
  </div>
</template>

<style>

</style>
